<script>
    import { onMount } from "svelte";
    import {
        getFormatDateAndTime,
        showError,
        showException,
    } from "../../Utils/utilFunctions.svelte";
    import { apiMethods } from "../../Services/index.svelte";
    import { DateInput, NotificationModal } from "./index.svelte";

    export let row = {};
    export let type;
    export let onFinish = () => {};

    let transactionDate = "",
        displayDate = "",
        newTransactionDate = "",
        receivedDate = "";

    let isUpdatingTransactionDate = false,
        isEditModalOpen = false;

    $: transactionDate = _getTransactionDate(row);
    $: displayDate = _getDisplayDate(row);

    onMount(() => {
        transactionDate = _getTransactionDate(row);
        displayDate = _getDisplayDate(row);
        receivedDate = _getReceivedDate(row);
    });

    const updateTransactionDate = async () => {
        isUpdatingTransactionDate = true;

        _syncNewTransactionDate();

        await updatePayment();

        closeEditModal();

        isUpdatingTransactionDate = false;
    };

    const updatePayment = async () => {
        let newPaymentObj = {};

        if (type == "ReceiptsTable") newPaymentObj = { ...row.payments[0] };
        else newPaymentObj = { ...row };

        await apiMethods.putMethod
            .updatePayment({ ...newPaymentObj })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to update receive date of this payment, please refresh the page and try again and contact support if the issue persists.",
                    );
                else onFinish();
            })
            .catch((err) => showException(err));
    };

    const openEditModal = () => {
        isEditModalOpen = true;
        newTransactionDate = transactionDate;
    };

    const closeEditModal = () => {
        isEditModalOpen = false;
        newTransactionDate = "";
    };

    // HELPER FUNCTIONS
    const _getTransactionDate = (rowData) => {
        switch (type) {
            case "ReceiptsTable":
                return _getTransactionDateFromArr(rowData.payments);
            case "EstimatePaymentTable":
            case "InvoicePaymentTable":
            case "PatientEncounterPaymentTable":
                return _getTransactionDateFromStr(rowData.transactionDate);
            default:
                return "";
        }
    };

    const _getReceivedDate = (rowData) => {
        switch (type) {
            case "ReceiptsTable":
                return _getReceiveDateFromArr(rowData.payments);
            case "EstimatePaymentTable":
            case "InvoicePaymentTable":
            case "PatientEncounterPaymentTable":
                return _getReceiveDateFromStr(rowData.receivedDate);
            default:
                return "";
        }
    };

    const _getDisplayDate = (rowData) => {
        switch (type) {
            case "ReceiptsTable":
                return _getDisplayDateFromArr(rowData.payments);
            case "EstimatePaymentTable":
            case "InvoicePaymentTable":
            case "PatientEncounterPaymentTable":
                return _getDisplayDateFromStr(rowData.transactionDate);
            default:
                return "";
        }
    };

    const _getTransactionDateFromArr = (paymentsArr = []) => {
        if (
            !paymentsArr.length ||
            !paymentsArr[0].transactionDate ||
            paymentsArr[0].transactionDate == "0001-01-01T00:00:00"
        )
            return "-";

        return paymentsArr[0].transactionDate;
    };

    const _getDisplayDateFromArr = (paymentsArr = []) => {
        if (
            !paymentsArr.length ||
            !paymentsArr[0].transactionDate ||
            paymentsArr[0].transactionDate == "0001-01-01T00:00:00"
        )
            return "-";

        const dateArr = paymentsArr[0].transactionDate.split("T")[0].split("-");

        if (Number(dateArr[0]) < 1900) return "-";

        return getFormatDateAndTime(paymentsArr[0].transactionDate);
    };

    const _getTransactionDateFromStr = (dateStr = "") => {
        if (!dateStr || dateStr == "0001-01-01T00:00:00") return "-";

        return dateStr;
    };

    const _getDisplayDateFromStr = (dateStr = "") => {
        if (!dateStr || dateStr == "0001-01-01T00:00:00") return "-";

        return getFormatDateAndTime(dateStr);
    };

    const _getReceiveDateFromArr = (paymentsArr = []) => {
        if (
            !paymentsArr.length ||
            !paymentsArr[0].receivedDate ||
            paymentsArr[0].receivedDate == "0001-01-01T00:00:00"
        )
            return null;

        return paymentsArr[0].receivedDate;
    };

    const _getReceiveDateFromStr = (dateStr = "") => {
        if (!dateStr || dateStr == "0001-01-01T00:00:00") return null;

        return dateStr;
    };

    const _syncNewTransactionDate = () => {
        switch (type) {
            case "ReceiptsTable":
                row.payments[0].transactionDate = newTransactionDate;
                return;
            case "EstimatePaymentTable":
            case "InvoicePaymentTable":
            case "PatientEncounterPaymentTable":
                row.transactionDate = newTransactionDate;
                return;
            default:
                return;
        }
    };
</script>

<div class="flex flex-row items-center justify-start">
    {#if displayDate == "-"}
        <span class="text-left cursor-default">{displayDate}</span>
    {:else}
        <span
            class="text-left cursor-pointer underline"
            on:click|preventDefault={openEditModal}
        >
            {displayDate}
        </span>
    {/if}
</div>

<NotificationModal
    isModalOpen={isEditModalOpen}
    title="Update Receive Date"
    cancelText="Cancel"
    submitText={isUpdatingTransactionDate ? "Updating" : "Update"}
    isConfirming={isUpdatingTransactionDate}
    closeModal={closeEditModal}
    contentClass="oveflow-x-hidden p-6 flex flex-col"
    closeModalFunction={closeEditModal}
    confirmAction={updateTransactionDate}
>
    <div class="flex flex-col gap-y-4">
        <p class="w-36 text-lg">Received Date:</p>

        <DateInput
            bind:value={newTransactionDate}
            showTime
            wrapperClass="px-0 input w-full max-w-xs input-sm input-bordered"
            wrapperClassFocus="inputFocus"
            maxDate={receivedDate ? receivedDate : null}
        />
    </div>
</NotificationModal>
